export default __webpack_public_path__ + "static/media/Implants.ea1cb68b.png";